/**
 * A project still being scoped (G5): nothing is checked out yet. Resume the saved scoping
 * conversation and create the project from its reviewed proposal.
 */
import { MessagesSquare } from 'lucide-react'
import { useState } from 'react'
import type { Project } from '../../lib/types.js'
import { Button } from '../ui.js'
import { ScopeProjectDialog } from './ScopeProjectDialog.js'

export function ScopingBanner({ project }: { project: Pick<Project, 'id' | 'setup'> }) {
  const [open, setOpen] = useState(false)
  if (project.setup?.state !== 'scoping') return null
  return (
    <div
      className="mb-3 flex flex-wrap items-center gap-2 rounded-xl border border-border-subtle bg-surface-1 px-3 py-2 text-[14px]"
      data-scoping-banner
    >
      <MessagesSquare size={16} aria-hidden="true" className="text-text-3" />
      <span className="min-w-0 flex-1 text-text-2">
        Being scoped with an agent. Nothing is checked out yet; the conversation is saved.
      </span>
      <Button size="sm" variant="primary" onClick={() => setOpen(true)}>
        Continue scoping
      </Button>
      {open ? <ScopeProjectDialog projectId={project.id} onClose={() => setOpen(false)} /> : null}
    </div>
  )
}
